import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlightTwoLastDigits',
  standalone: true
})
export class HighlightTwoLastDigitsPipe implements PipeTransform {

  constructor(
    protected readonly _sanitizer: DomSanitizer
  ) {}

  transform(value: string): SafeHtml | string {
    return value ? this._sanitizer.bypassSecurityTrustHtml(this._getTransformedValue(value)) : '';
  }

  private _getTransformedValue(value: string): string {
    return value.replace(/[0-9]+(?!.*[0-9])/, match => `<span class="account-balance--trifle">${match}</span>`);
  }

}
